// @flow
import SocialHub from 'components/social/SocialHub';
import { connect } from 'react-redux';

import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/social/SocialHub';
import { fetchInstagramPosts } from 'actions/instagramActions';
import { fetchFacebookPosts } from 'actions/facebookActions';
import { fetchTwitterPosts } from 'actions/twitterActions';
import { fetchYoutubePosts } from 'actions/youtubeActions';
import { STATUS_SUCCESS, STATUS_LOADING } from 'constants/statusConstants';

export default connect(
  (state: StateType): StateProps => ({
    posts: [
      ...state.instagramState.posts,
      ...state.twitterState.posts,
      ...state.facebookState.posts,
      ...state.youtubeState.posts
    ],
    status:
      state.instagramState.status === STATUS_SUCCESS ||
      state.twitterState.status === STATUS_SUCCESS ||
      state.facebookState.status === STATUS_SUCCESS ||
      state.youtubeState.status === STATUS_SUCCESS
        ? STATUS_SUCCESS
        : STATUS_LOADING,
    titleClub: state.settingsState.title,
    liens_rs: state.settingsState.liens_rs
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchInstagramPosts: () => dispatch(fetchInstagramPosts()),
    fetchFacebookPosts: () => dispatch(fetchFacebookPosts()),
    fetchTwitterPosts: () => dispatch(fetchTwitterPosts()),
    fetchYoutubePosts: () => dispatch(fetchYoutubePosts())
  })
)(SocialHub);
